<div class="row">
    <div class="col-md-2">
        <label for="ID" class="form-label">Product ID</label>
        <input type="text" class="form-control" [(ngModel)]="idVal" placeholder="">
    </div>
    <div class="col-md-4">
        <label for="Book Type" class="form-label">Book Type</label>
        <app-drop-down [settings]="dropdownSettingsProductType" [list]="dropdownListProductType"></app-drop-down>
    </div>

    <div class="col-md-4">
        <label for="Book Type" class="form-label">Book Type</label>
        <app-drop-down [settings]="dropdownSettingsBookType" [list]="dropdownListBookType"></app-drop-down>
    </div>
    <div class="col-md-2 mt-4">
        <button type="submit" class="btn search-btn" (click)="searchProduct()">Search</button>
    </div>
</div>